import React, { useRef, useEffect } from 'react';
import { gsap } from '../../../../gsap';
import './Helmet.scss';

function FutureHelmet({ screenWidth, animationRef }) {
  const futureHelmetCanvas = useRef();
  const futureHelmetSection = useRef();
  const futureHelmetAnimation = useRef();
  const images = useRef([]);
  const ratio = useRef();

  useEffect(() => {
    ratio.current = screenWidth > 480 ? 1 : 1.777;
    images.current = [];
    // set canvas properties
    const canvas = futureHelmetCanvas.current.getContext('2d');
    // Set the size of the canvas
    futureHelmetCanvas.current.width =
      screenWidth > 480 ? Math.min(window.innerWidth * 0.5, 794) : window.innerWidth;
    futureHelmetCanvas.current.height = futureHelmetCanvas.current.width * ratio.current;

    // Count the frames and set the path to the images
    const frameCount = 45;
    const currentFrame = (index, screenSize) =>
      `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/future/helmet/${screenSize}/Access_HELMET${(
        index + 1
      )
        .toString()
        .padStart(2, '0')}.png`;
    // Set start frame

    const target = {
      frame: 0
    };

    // Go through frames from start to finish
    const anim = gsap.timeline({
      scrollTrigger: {
        trigger: futureHelmetAnimation.current,
        start: 'top 25%',
        endTrigger: futureHelmetSection.current,
        end: 'bottom bottom',
        scrub: 1
      }
    });

    if (screenWidth < 481) {
      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i, 'mobile');
        images.current.push(img);
      }
    } else {
      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i, 'desktop');
        images.current.push(img);
      }
    }

    anim.add('start').to(
      target,
      {
        frame: frameCount - 1,
        snap: 'frame',
        duration: 5,
        ease: 'linear',
        onUpdate: () => {
          render();
        }
      },
      'start'
    );

    images.current[0].onload = render;

    function render() {
      canvas.clearRect(0, 0, futureHelmetCanvas.current.width, futureHelmetCanvas.current.height);
      canvas.drawImage(
        images.current[target.frame],
        0,
        0,
        futureHelmetCanvas.current.width,
        futureHelmetCanvas.current.height
      );
    }
  }, [screenWidth, images]);

  return (
    <section className="helmet helmet-future" ref={futureHelmetSection}>
      <div className="helmet__upper helmet__upper-future">
        <h3 className="helmet__title helmet__title-future">
          In the future, innovative technology like 3D scanning and printing may be used to custom
          fit suit components to each individual astronaut.
        </h3>
      </div>
      <div className="helmet__lower helmet__lower-future">
        <div className="helmet__animation helmet__animation-future" ref={futureHelmetAnimation}>
          <canvas className="helmet__animation__canvas" ref={futureHelmetCanvas} />
        </div>
        <div className="helmet__lower__text helmet__lower__text-future">
          <h3 className="helmet__lower__text__title helmet__lower__text__title-future">
            Heads-Up Display
          </h3>
          <p className="helmet__lower__text__copy helmet__lower__text__copy-future">
            Future helmets may include internal “heads-up displays,” which could be capable of
            displaying critical mission information like environmental data and astronaut vital
            signs.
          </p>
        </div>
      </div>
    </section>
  );
}

export default FutureHelmet;
